import moment from 'moment';

export const CALENDAR_LEGEND_ID = {
  planned: 1,
  needReport: 2,
  completedWithReport: 3,
  failed: 4,
  completedWithoutReport: 5,
  inProcess: 6,
};

export const CALENDAR_LEGEND_ORDER = [
  CALENDAR_LEGEND_ID.planned,
  CALENDAR_LEGEND_ID.inProcess,
  CALENDAR_LEGEND_ID.needReport,
  CALENDAR_LEGEND_ID.completedWithReport,
  CALENDAR_LEGEND_ID.failed,
  CALENDAR_LEGEND_ID.completedWithoutReport,
];

export const CALENDAR_LEGEND_COLORS = {
  [CALENDAR_LEGEND_ID.planned]: '#989898',
  [CALENDAR_LEGEND_ID.needReport]: '#ffd966',
  [CALENDAR_LEGEND_ID.completedWithReport]: '#25c05a',
  [CALENDAR_LEGEND_ID.failed]: '#000000',
  [CALENDAR_LEGEND_ID.completedWithoutReport]: '#FF6666',
  [CALENDAR_LEGEND_ID.inProcess]: '#00CED1',
};

export const CALENDAR_LEGEND_TEXT = {
  [CALENDAR_LEGEND_ID.planned]: 'Мероприятие планируется',
  [CALENDAR_LEGEND_ID.needReport]: 'По прошедшему мероприятию требуется отчет',
  [CALENDAR_LEGEND_ID.completedWithReport]: 'Запланированное мероприятие состоялось, отчет предоставлен',
  [CALENDAR_LEGEND_ID.failed]: 'Запланированное мероприятие не состоялось',
  [CALENDAR_LEGEND_ID.completedWithoutReport]: 'Запланированное мероприятие состоялось, отчет не предоставлен',
  [CALENDAR_LEGEND_ID.inProcess]: 'Мероприятие в процессе',
};

export const CALENDAR_LEGEND_TITLES = {
  [CALENDAR_LEGEND_ID.planned]: 'Запланированное',
  [CALENDAR_LEGEND_ID.needReport]: 'Требуется отчет',
  [CALENDAR_LEGEND_ID.completedWithReport]: 'Cостоявшееся',
  [CALENDAR_LEGEND_ID.failed]: 'Несостоявшееся',
  [CALENDAR_LEGEND_ID.completedWithoutReport]: 'Cостоявшееся без отчета',
  [CALENDAR_LEGEND_ID.inProcess]: 'В процессе',
};

export const ForeignEconomicRelationTabs = {
  KEY_INDEX: { id: 1, text: 'Ключевые показатели' },
  TRADE_TURNOVER: { id: 2, text: 'Товарооборот' },
  COMMON_INFO: { id: 3, text: 'Общие сведения' },
  COUNTRY_PARTNERS: { id: 4, text: 'Основные страны-партнеры' },
  EVENTS: { id: 5, text: 'Мероприятия' },
  VES_ORGANIZATION: { id: 6, text: 'Орган, ответственный за ВЭС субъекта РФ' },
  AGREEMENTS: { id: 7, text: 'Соглашения' },
};

export const MAP_REGION_SCALE = [
  {
    color: '#D9D9D9',
    value: '0',
  },
  {
    color: '#BAD7F3',
    value: '1-20',
    from: 1,
    to: 20,
  },
  {
    color: '#7ABFFF',
    value: '21-40',
    from: 21,
    to: 40,
  },
  {
    color: '#2A97F9',
    value: '41-60',
    from: 41,
    to: 60,
  },
  {
    color: '#096BC7',
    value: '61-80',
    from: 61,
    to: 80,
  },
  {
    color: '#013F78',
    value: '>81',
    from: 81,
  },
];

export const OPTIONS_EVENTS_ID = 1;

export const SKELETON_GRAPHS = {
  graph: {
    datasets: [],
  },
  list: [],
};

export const AGREEMENTS_HISTORY_STATUS = Object.freeze({
  1: {
    id: '1',
    name: 'Реализуется',
    type: 'yellow',
  },
  2: {
    id: '2',
    name: 'Завершен',
    type: 'green',
  },
  3: {
    id: '3',
    name: 'Приостановлен',
    type: 'red',
  },
  4: {
    id: '4',
    name: 'В перспективе',
    type: 'darkBlue',
  },
});

export const PERIOD_CAP = 'Прошедший период';

export const DEFAULT_BASE_FILTER = {
  federalDistrictId: null,
  regionRfId: null,
};

export const DEFAULT_IMPLEMENTATION_FILTER = {
  startDate: moment().subtract(1, 'year').startOf('year').format(),
  endDate: moment().subtract(1, 'year').endOf('year').format(),
  partnerCountryId: null,
  ...DEFAULT_BASE_FILTER,
};

export const AgreementStatus = {
  PLAN_FOR_REALIZE: 'Запланировано к реализации',
  REALIZE: 'Реализуется',
  STOPPED: 'Приостановлен',
  DONE: 'Завершен',
};

export const EVENTS_PASSPORT_RELATION_LIMIT = 5;

export const VES_EVENT_STATUSES_IDS = {
  PLANNED: 1,
  COMPLETED: 2,
  FAILED: 3,
  IN_PROGRESS: 4,
};

export const EVENTS_TABLE_ACTIONS = 'eventsTableActions';

export const BASE_EVENTS_ORGANIZER = 'Минэкономразвития России';
